import {
	GET_SITES,
	SET_SELECTED,
	GET_SITE,
	EDIT_ROW_VALUE,
	UPDATE_SELECTED_ROWS
} from '../actions/PlanningActions.js';

const dataTableMapping = {
	'2g': 'builderCells2g',
	'3g': 'builderCells3g',
	'4g': 'builderCells4g',
	'5g': 'builderCells5g'
};

const initialState = {
	sites: [],
	selected: null,
	site: undefined,
	selectedRows: { '2g': [], '3g': [], '4g': [], '5g': [] }
};

const planningReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_SITES: {
						return {
							...state,
							sites: action.sites
						};
					}
					case SET_SELECTED: {
						return {
							...state,
							selected: action.selected
						};
					}
					case GET_SITE: {
						return {
							...state,
							site: action.site
						};
					}
					case EDIT_ROW_VALUE: {
						const { site } = state;
						const newSite = JSON.parse(JSON.stringify(site));
						const siteData = newSite[dataTableMapping[action.tech]];
						const cellData = siteData.find(data => data.id === action.id);
						cellData[action.key] = action.value;
						return {
							...state,
							site: newSite
						};
					}
					case UPDATE_SELECTED_ROWS: {
						const { selectedRows } = state;
						const newSelectedRows = JSON.parse(JSON.stringify(selectedRows));
						newSelectedRows[action.tech] = action.selectedRows;
						return {
							...state,
							selectedRows: newSelectedRows
						};
					}
					default: {
						return state;
					}
	}
};

export default planningReducer;
